// src/components/layout/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import Icon from "../ui/Icon";

/**
 * Footer with working route-based links. Legal pages live at /terms,
 * /privacy, /refund. Section anchors live on the landing page (#how,
 * #faq, #contact).
 */
export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      className="mt-16"
      style={{ background: "var(--bg)", borderTop: "1px solid var(--border)" }}
    >
      <div className="mx-auto max-w-[1180px] px-4 sm:px-6 py-10">
        <div className="grid gap-8 md:grid-cols-4">
          <div>
            <Logo size="sm" />
            <p
              className="mt-3 text-[13px] leading-relaxed"
              style={{ color: "var(--txt-2)" }}
            >
              Data-driven number picks for Mega Millions &amp; Powerball,
              backed by a model trained on real draw history. For
              entertainment purposes only.
            </p>
            <p
              className="mt-3 text-[12px] leading-relaxed"
              style={{ color: "var(--txt-3)" }}
            >
              LottoGPT does not sell lottery tickets, collect winnings, or
              guarantee any outcome. You're responsible for purchasing
              official tickets through an authorized retailer.
            </p>
          </div>

          <FooterCol
            heading="Products"
            links={[
              { to: "/plans",     label: "Plans" },
              { to: "/dashboard", label: "Dashboard" },
              { to: "/generator", label: "Generator" },
            ]}
          />

          <FooterCol
            heading="Resources"
            links={[
              { to: "/#how", label: "How it Works" },
              { to: "/#faq", label: "FAQ" },
              { to: "/contact", label: "Contact" },
            ]}
          />

          <FooterCol
            heading="Legal"
            links={[
              { to: "/terms",   label: "Terms of Use" },
              { to: "/privacy", label: "Privacy Policy" },
              { to: "/refund",  label: "Refund Policy" },
            ]}
          />
        </div>

        <div
          className="mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4"
          style={{ borderTop: "1px solid var(--border)" }}
        >
          <p
            className="text-[12px] text-center sm:text-left"
            style={{ color: "var(--txt-3)" }}
          >
            © {year} LottoGPT. All rights reserved · For entertainment purposes only · 18+
          </p>
          <div className="flex items-center gap-4 text-[12px]" style={{ color: "var(--txt-3)" }}>
            <span className="inline-flex items-center gap-1.5">
              <Icon name="shield-check" size={13} style={{ color: "var(--gold)" }} />
              SSL secured
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ heading, links }) {
  return (
    <div>
      <div
        className="text-[13px] font-semibold mb-3"
        style={{ color: "var(--txt)" }}
      >
        {heading}
      </div>
      <ul className="space-y-2">
        {links.map((l) => (
          <li key={l.to + l.label}>
            <Link
              to={l.to}
              className="text-[13px] transition-colors"
              style={{ color: "var(--txt-2)" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "var(--gold)")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "var(--txt-2)")}
            >
              {l.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
